import { render, staticRenderFns } from "./OrderTotal.vue?vue&type=template&id=13daef24&scoped=true"
import script from "./OrderTotal.vue?vue&type=script&lang=js"
export * from "./OrderTotal.vue?vue&type=script&lang=js"
import style0 from "./OrderTotal.vue?vue&type=style&index=0&id=13daef24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13daef24",
  null
  
)

export default component.exports